import IConfigFile from './IConfigFile';

export default interface IConfiguration {
    getConfig(): IConfigFile;
}
